import React from 'react';

import PropTypes from 'prop-types';

import style from './ModalCommon.module.scss';

function ModalCommonHeader({title, children}) {
  return <div className={style.header}>{children || <span className={style.title}>{title}</span>}</div>;
}

export default ModalCommonHeader;

ModalCommonHeader.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
};

ModalCommonHeader.defaultProps = {
  title: '',
  children: null,
};
